const REQUIRED_METHODS = ['ensureSchema', 'onBoot', 'getSummary', 'purge']

const isFunction = (value) => typeof value === 'function'

export function assertSqliteFeatureContract(feature, source = 'sqlite feature') {
    if (!feature || typeof feature !== 'object') {
        throw new Error(`[SQLite][Feature] Invalid ${source}: expected object`)
    }

    const key = feature.key
    if (typeof key !== 'string' || key.trim().length === 0) {
        throw new Error(`[SQLite][Feature] Invalid ${source}: "key" must be a non-empty string`)
    }

    for (const method of REQUIRED_METHODS) {
        if (!isFunction(feature[method])) {
            throw new Error(`[SQLite][Feature] Invalid ${source} "${key}": "${method}" must be a function`)
        }
    }
}

export function defineSqliteFeature(feature) {
    assertSqliteFeatureContract(feature)
    return Object.freeze(feature)
}
